import {type Template, chooseAndDownloadTemplate} from '@helpers/select-template';

import {
  BACKEND_SIMPLE_NEST_REPO,
  DEFAULT_BACKEND_SIMPLE_NEST_PROJECT_NAME
} from '../constants/templates';

export const initBackend = async (): Promise<void> => {
  const templates: Template[] = [
    {
      name: DEFAULT_BACKEND_SIMPLE_NEST_PROJECT_NAME,
      repo: BACKEND_SIMPLE_NEST_REPO
    }
  ];

  await chooseAndDownloadTemplate(templates);
};
